/** Created by azhou on 2019/3/14.*/
<template>
  <div>
    <public-title>{{storeInfo.type === 99?'银行卡审核':'银行卡列表'}}
      <div slot="right" class="ml-auto" v-if="storeInfo.type != 99">
        <el-button size="small" type="primary" @click="addBankcard">添加银行卡</el-button>
        <!-- <span class="text-link ml-5 h6" v-show="isGroup" @click="$router.back()">返回列表</span> -->
      </div>
    </public-title>
    <div class="load-area">
      <p v-if="StoreBankcardList.total<=0">当前没有数据</p>
      <div v-else>
        <ul class="list-head"><li class="w-50" v-for="item in storeInfo.type === 99?titleArrManage:titleArr" :key="item">{{item}}</li></ul>
        <ul class="list-item" v-for="(Itemize,index) in StoreBankcardList.lists" :key="Itemize.id">
          <li class="w-50 list-item-col"><span class="text-success mr-2" v-show="Itemize.is_default" v-if="$GFUN.isInArray([2,3],storeInfo.type)">[结算卡]</span>{{Itemize.type==1?'企业':'个人'}}</li>
          <li class="w-50 list-item-col">{{Itemize.truename}}</li>
          <li class="w-50 list-item-col">{{Itemize.bank_name}}</li>
          <li class="w-50 list-item-col">{{Itemize.branch}}</li>
          <li class="w-50 list-item-col">{{Itemize.bank_card}}</li>

          <li class="w-50 list-item-col" >
            <span class="is-focu" @click="openNotes(index)" v-if="Itemize.notes!=true" >{{Itemize.remark|| '无'}}</span>
            <el-input
             class="is-inpuy"
              :ref="'playBtn'+index"
              type="text"
              placeholder="请输入内容"
              v-model="Itemize.remark"
              maxlength="15"
              @blur="notes($event,Itemize.id,index)"
              show-word-limit
            ></el-input>
          </li>
          <li class="w-50 list-item-col" :class="Itemize.verify==2?'text-warning':Itemize.verify==1?'text-success':'text-danger'" v-if="$GFUN.isInArray([2,3],storeInfo.type)">{{Itemize.verify | formatVar('verifyType')}}</li>
          <li class="w-50 list-item-col-end" v-if="$GFUN.isInArray([2,3],storeInfo.type)">
            <el-dropdown @command="handleCommand($event,Itemize)">
              <span class="el-dropdown-link text-link">
                操作<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item  command="1" v-show="!Itemize.is_default&&Itemize.verify==1" :disabled="Itemize.verify==1?false:true">设为结算卡</el-dropdown-item>
                <el-dropdown-item  command="2" :disabled="Itemize.verify!=2&&!Itemize.is_default||Itemize.verify==0&&Itemize.is_default?false:true">删除</el-dropdown-item>
                <el-dropdown-item  command="3" :disabled="Itemize.verify==0&&!Itemize.is_default||Itemize.verify==0&&Itemize.is_default?false:true">修改</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li class="w-50 list-item-col-end text-link" v-if="storeInfo.type === 99" @click="careful(Itemize.id)">
            去审核
          </li>
        </ul>
        <el-pagination background layout="prev, pager, next" class="mt-4"
                      :total="StoreBankcardList.total" :current-page="Number(queryCon.page)"
                      @current-change="v => this.currentPage=v"/>
      </div>
    </div>
    <!-- 安全验证 -->
    <verify-number url="/pc/User/GetSafeCode"  :number="userLoginMessage.mobile" v-if="showShopCar" @submitOrder="submitOrder" @switch="showShopCar=!showShopCar"> </verify-number>
  </div>
</template>

<script>
  import { mapGetters, mapActions,mapState,mapMutations } from 'vuex'

  export default {
    name: 'StoreBankcardLists',
    computed: {
      ...mapState(['StoreBankcardList','userLoginMessage']),
      ...mapGetters(['storeInfo','isGroup']),
      queryCon() { return this.$route.query },
    },
    watch:{
      queryCon() { console.log(this.queryCon,page); this.getStoreBankcardLists({...this.queryCon,page:this.currentPage}); },
      currentPage() { this.$router.push({name:this.$route.name,query:{...this.queryCon,page:this.currentPage}}) }
    },
    data() {
      return {
        item:{},                                  //当前项
        modes:0,                                   //0:设置默认1:删除
        showShopCar: false,                       //安全弹窗
        titleArr:['所属','企业名称/个人姓名','开户银行','支行名称','银行卡号','备注','状态','操作'],
        titleArrManage:['所属','企业名称/个人姓名','开户银行','支行名称','银行卡号','备注','操作'], 
        currentPage:1,
      }
    },
    mounted() {
      this.UPDATECURRENTSTORE({storeId:this.queryCon.store})
      this.getStoreBankcardLists({page:this.currentPage});
    },
    beforeDestroy() {
      this.UPDATECURRENTSTORE({storeId:''})
    },
    methods:{
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['getStoreBankcardLists','deleteStoreBankcard','setStoreBankcard','getStoreBankcardNotes']),
      //开打备注
      openNotes(index) {
        // if(this.storeInfo!=3){ return; }
        this.StoreBankcardList.lists.forEach((item, i) => { if (i !== index) {item.notes = false }else{item.notes = true} });
        this.$set(this.StoreBankcardList.lists, index, {notes:true,...this.StoreBankcardList.lists[index]});
        this.$refs[`playBtn${index}`][0].focus();
      },  
      //修改备注
      notes(e,id,index){
        this.StoreBankcardList.lists.forEach((item, i) => {item.notes = false });
        this.getStoreBankcardNotes({ id:id,remark:e.target.value })
      },
      //点击操作按钮
      handleCommand(command,Itemize) {
        switch (command) {
          case '1':
            this.setDefault(Itemize)
            break
          case '2':
            this.deleteBankcard(Itemize)
            break
          case '3':
            this.deleteBankmodify(Itemize)
            break
          default:
        }
      },
      //跳转审核页面
      careful(id){
        this.$router.push({name:'ReviewBankcard',query:{id:id}})
      },
      //设置银行卡为默认
      setDefault(item) {
        // if (!this.$GFUN.powerIsInArray([355,169,357,380,622])) { this._alert('您没有相关权限！',null,'error'); return; }
        let {truename,bank,province,city,branch,card} = item;
        this._confirm('确定将该银行卡设置为默认结算卡嘛？', () => {
          this.modes=0;
          this.item=item;
          this.submitOrder();
          // this.setStoreBankcard({ truename,bank,province,city,branch,card,bankcard_id:item.id })
        })
      },
      //添加银行卡
      addBankcard() {
        // if (!this.$GFUN.powerIsInArray([239,165,284,381,615])) { this._alert('您没有相关权限！',null,'error'); return; }
        this.$router.push({name:'addBankcard',query:{modes:0,store:this.$route.query.store,GST:this.$route.query.GST}})
      },
       //修改银行卡
      deleteBankmodify(item){
        // if (!this.$GFUN.powerIsInArray([239,165,284,381,615])) { this._alert('您没有相关权限！',null,'error'); return; }
        this.$router.push({name:'addBankcard',query:{modes:1,id:item.id, store:this.$route.query.store,GST:this.$route.query.GST}})
      },
      //删除银行卡
      deleteBankcard(item) {
        // if (!this.$GFUN.powerIsInArray([242,168,287,384,616])) { this._alert('您没有相关权限！',null,'error'); return; }
        if (this.StoreBankcardList.total <= 1) { this._alert('请至少保留一条银行卡信息',null,'error'); return }
        this._confirm('确认删除么？',() => { 
          this.modes=1;
          this.item=item;
          this.submitOrder(); 
          // this.deleteStoreBankcard(item.id) 
        });
      },
      //安全验证通过
      submitOrder(e){
        if(this.modes==0){
          this.setStoreBankcard({ id:this.item.id })
        }else{
          this.deleteStoreBankcard({id:this.item.id}) 
        }
        this.showShopCar=false;
        console.log('安全验证通过',e)
      },
    },
  }
</script>
<style scoped>
.list-item-col{
  position: relative;
}
.is-focu{
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9;
  min-height: 50px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
</style>
<style>
  .is-inpuy .el-input__inner{
    border: none;
  }
</style>